import type { ReactNode } from 'react';

/**
 * App shell: full-height column with a sticky header and a gray-50 scroll area.
 * Modeled after Archer Console's AppLayout.
 */
export function AppLayout({ header, children }: { header: ReactNode; children: ReactNode }) {
  return (
    <div className="flex flex-col h-screen bg-gray-50 text-ink font-sans">
      {header}
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}

/**
 * Standard inner page wrapper: padding + max-width.
 */
export function PageContainer({ children }: { children: ReactNode }) {
  return <div className="px-6 py-5">{children}</div>;
}

/**
 * Title row at the top of a page. e.g. "Pending queue  35 total".
 */
export function PageTitle({
  title,
  subtitle,
  total,
  totalLabel = 'total',
  right,
}: {
  title: string;
  subtitle?: string;
  total?: number | string;
  totalLabel?: string;
  right?: ReactNode;
}) {
  return (
    <div className="flex items-baseline justify-between mb-5">
      <div className="flex items-baseline gap-3">
        <h2 className="text-xl font-semibold text-ink">{title}</h2>
        {total !== undefined && (
          <span className="text-sm text-gray-500">
            {total} {totalLabel}
          </span>
        )}
      </div>
      {right}
      {!right && subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
    </div>
  );
}
